import { render, staticRenderFns } from "./MainContentHeader.vue?vue&type=template&id=74275756&scoped=true&"
import script from "./MainContentHeader.vue?vue&type=script&lang=js&"
export * from "./MainContentHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainContentHeader.vue?vue&type=style&index=0&id=74275756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74275756",
  null
  
)

export default component.exports